"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../common");
exports.TextInput = (0, react_1.forwardRef)(({ title, defaultValue = '', handlerUpdate, noShowButtonArea = false, buttonStyle = {
    width: '123px',
}, buttonOption, ...props }, ref) => {
    const inputRef = (0, react_1.useRef)(null);
    const [value, setValue] = (0, react_1.useState)(defaultValue);
    (0, react_1.useImperativeHandle)(ref, () => ({
        focus: () => inputRef.current?.focus(),
        getValue: () => value,
        setValue: (newValue) => {
            setValue(newValue);
            if (inputRef.current) {
                inputRef.current.value = newValue;
            }
        },
    }));
    const onChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);
        handlerUpdate?.(newValue);
    };
    (0, react_1.useEffect)(() => {
        setValue(defaultValue);
        if (inputRef.current) {
            inputRef.current.value = defaultValue;
        }
    }, [defaultValue]);
    return (react_1.default.createElement("div", { className: "text-input" },
        title && react_1.default.createElement("label", { className: "title" }, title),
        react_1.default.createElement("div", { className: "wrap" },
            react_1.default.createElement("input", { ref: inputRef, value: value, onChange: onChange, ...props }),
            !noShowButtonArea && (react_1.default.createElement("div", { style: buttonStyle }, buttonOption && (react_1.default.createElement(common_1.Button, { className: buttonOption.className, text: buttonOption.title, onClick: buttonOption.handlerClick })))))));
});
